import "./style.scss";
import { FC, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { universityProgramsEducation, universityProgramsQualification } from "@/src/constants/university-programs";
import { Link } from "react-router-dom";
import ProgramsArrow from "@/src/assets/Programs/ProgramsArrow.png";
import RedLineForTitle from "../RedLineForTitle/RedLineForTitle";

interface IPrograms {
  pageId?: string;
}

const Programs: FC<IPrograms> = ({ pageId }) => {
  const [currentTitle, setCurrentTitle] = useState<string>("");

  useEffect(() => {
    switch (pageId) {
      case "education-medical":
        setCurrentTitle("Факультет медицины");
        break;
      case "education-business":
        setCurrentTitle("Факультет бизнеса");
        break;
      case "education-sciences":
        setCurrentTitle("Факультет социально-гуманитарных наук");
        break;
      case "education-technology":
        setCurrentTitle("Факультет IT");
        break;
      case "education-arch":
        setCurrentTitle("Архитектурно-инженерный факультет");
        break;
      case "education-law":
        setCurrentTitle("Факультет права");
        break;
    }
  }, [pageId]);

  const programs = useMemo(() => {
    if (!pageId) return [];
    const cleanPath = pageId.replace("programs/", "");
    const isEducation = cleanPath.startsWith("education");
    const isQualification = cleanPath.startsWith("qualification");

    const source = isEducation ? universityProgramsEducation : isQualification ? universityProgramsQualification : [];

    const programBlock = source.find((item) => item.path === cleanPath);
    return programBlock?.programs || [];
  }, [pageId]);

  useLayoutEffect(() => {
    const timeout = setTimeout(() => {
      const items = document.querySelectorAll<HTMLElement>(".programs-item");
      if (!items.length) return;

      let lastRowTop = 0;

      items.forEach((item) => {
        const top = item.getBoundingClientRect().top;
        if (top > lastRowTop) lastRowTop = top;
      });

      items.forEach((item) => {
        item.style.borderBottom = "";
      });

      items.forEach((item) => {
        const top = item.getBoundingClientRect().top;
        if (top === lastRowTop) {
          item.style.borderBottom = "none";
        }
      });
    }, 0);

    return () => clearTimeout(timeout);
  }, [programs]);

  return (
    <div className="container padding-top programs">
      {programs.length === 0 ? (
        <div className="programs-empty">
          <p>Нет программ</p>
        </div>
      ) : (
        <>
          {/* <div className="programs-title">
            <p>{currentTitle}</p>
          </div> */}
          <RedLineForTitle title={currentTitle} />

          <div className="programs-items">
            {programs.map((program, index) => (
              <Link to={program.path} className="programs-item" key={index}>
                <div className="programs-item-content">
                  <div className="programs-item-title">
                    <p>{program.name}</p>
                  </div>
                  <div className="programs-item-subtitle">
                    <p>{program.subName}</p>
                  </div>
                  <div className="programs-item-image">
                    <img src={ProgramsArrow} alt="Programs Img" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Programs;
